<template>
	<div class="catalog-search">
			<input type="text" v-model="keyword" v-on:keyup.enter="search" placeholder="商品検索">
      <button type="submit" v-on:click="search"><i class="fas fa-search"></i></button>
	</div>
</template>

<script>
  export default {
    data: function () {
      return {
        keyword: ""
      }
    },
    methods: {
      search: function () {
        var keyword = this.keyword.trim()
        if(keyword.length === 0){
          return
        }
        this.$router.push({name: "search", params: {Keyword: keyword}});
      }
    }
  }  
</script>
